'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoEasel = function IoEasel(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3.8 26.3v-15h27.5v15h-27.5z m30-18.8c0.7 0 1.2 0.5 1.2 1.3v20c0 0.7-0.5 1.2-1.2 1.2h-32.5c-0.8 0-1.3-0.5-1.3-1.2v-20c0-0.8 0.5-1.3 1.3-1.3h32.5z m-1.3 20v-17.5h-30v17.5h30z m-28.7 10l2.2-6.2h2.4l-2.1 6.2h-2.5z m14.9-35l1.3 3.8h-5l1.3-3.8h2.4z m7.9 28.8h2.4l2.3 6.2h-2.5z m-10.3 3.7v-3.7h2.5v3.7h-2.5z' })
        )
    );
};

exports.default = IoEasel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/easel.js
// module id = 2041
// module chunks = 0